export interface ExperienceInvestissementWorkFlow {
    Key: string,
    Libelle: string,
    Order: number
}

const OBJECTIFS_INVESTISSEMENT: string = "OIN";
const EXPERIENCE_INVESTISSEMENT: string = "EIN";
const CONNAISSANCE_RISQUES: string = "CRS";

export const ExperienceInvestissementWorkFlow = {
    OBJECTIFS_INVESTISSEMENT,
    EXPERIENCE_INVESTISSEMENT,
    CONNAISSANCE_RISQUES
}

export interface RegisterExperienceInvestissementBody {
    ReponseQuestionIdList: number[]
    CurrentFormStep: string
}

